import BackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import notFoundImage from "../../../assets/images/error404Image.png";
import { Container, ErrorImage, TextContainer } from "../../styled/NotFound";
import ErrorButton from "../errorButton/ErrorButton";

const NotFound = () => {
  return (
    <Container>
      <TextContainer>
        <ErrorImage src={notFoundImage} alt="404 error" />
        <Typography
          variant="overline"
          sx={{
            display: "flex",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: { xs: 12, md: 16 },
            color: "secondary.main",
          }}>
          Parece que no hay nada por aquí...
        </Typography>
      </TextContainer>
      <Link to="/">
        <ErrorButton text="Regresar" icon={<BackIcon />} />
      </Link>
    </Container>
  );
};

export default NotFound;
